export function getLatestOffer(offers = []) {
  if (!Array.isArray(offers) || offers.length === 0) return null;

  return offers.reduce((latest, current) => {
    if (!latest) return current;

    const latestDate = latest.offerLetter?.sendDate;
    const currentDate = current.offerLetter?.sendDate;

    if (!latestDate) return current;
    if (!currentDate) return latest;

    const latestTime = new Date(latestDate).getTime();
    const currentTime = new Date(currentDate).getTime();

    if (currentTime > latestTime) return current;
    if (currentTime < latestTime) return latest;

    return current;
  }, null);
}
